import React from 'react';
import EventStore from '@stores/EventStore';
import RouteConfig from './RouteConfig';
import '@css/main.css';

export default class Main extends React.Component {
    /* High level component that essentially will control app wide specifications if any. */
    constructor() {
        super();
        var queryString = window.location.search.slice(1);
        if(queryString) {
            var queryStringArr = queryString.split('&');
            queryStringArr.forEach(function(item) {
                var itemIndex = item.indexOf('=');
                sessionStorage.setItem(item.substr(0,itemIndex), item.substr(itemIndex+1));
            });
        }
    }

    componentDidMount() {
        EventStore.longPollEvents();
    }

    render() {
        return (
            <RouteConfig />
        );
    }
}


// WEBPACK FOOTER //
// ./src/Main.js